define('charts/layers/diagonals',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Diagonals = void 0;
    var Diagonals = /** @class */ (function () {
        function Diagonals(numLines) {
            this.lines = [];
            this.numLines = numLines;
        }
        Diagonals.prototype.init = function (chart) {
            // Add layer for diagonals
            this.svgGroup = chart.layers.space.append("g")
                .attr("class", "diagonal");
            // Add diagonal lines
            for (var i = 0; i < this.numLines; i++) {
                this.lines[i] = this.svgGroup.append("line")
                    .style("stroke-width", 1)
                    .style("stroke", "#ddd");
            }
        };
        Diagonals.prototype.update = function (chart) {
            var y0 = chart.yAxis[0].scale(0);
            var width = chart.width();
            // TODO: This overdraws the lines in height, and fails if chart is portrait.
            // const intercept = Math.min(chart.xAxis.scale.domain()[1], -chart.yAxis[0].scale.domain()[0])
            for (var i = 0; i < this.numLines; i++) {
                this.lines[i]
                    .attr("x1", 0)
                    .attr("y1", y0)
                    .attr("x2", width)
                    .attr("y2", y0 + width / (i + 1));
            }
        };
        Diagonals.prototype.remove = function () {
            this.svgGroup.remove();
        };
        return Diagonals;
    }());
    exports.Diagonals = Diagonals;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/diagonals.js.map;
